const basePath = '/recruiting/personal/applications'

export default {
  name: 'personalApplications',
  path: `${basePath}`,
  component: null,
  meta: {
    isInclude: false,
    mobileHomeMenu: {
      redirectPath: '/referral/my-job-applications/',
      iconClass: 'iconapplications',
      nameI18nKey: 'personal.applications.homeMenu.name',
      descI18nKey: 'personal.applications.homeMenu.desc'
    }
  }
}
